export default __webpack_public_path__ + "static/media/WD_20160903_0284_tn.292ee1fe.jpg";